module.exports = __webpack_public_path__ + "img/no-data.0dceb307.jpg";